import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Media } from 'foundations-components/transitional/components/Media';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { MediaLeft } from 'foundations-components/transitional/components/MediaLeft';
import CreateArticleButton from '../../components/CreateArticleButton';
import { getImportWizardUrl } from '../../routing/utils/externalUrls';
import { Link } from 'foundations-components/transitional/components/Link';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { NextIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ArticleZeroState = () => {
  return /*#__PURE__*/_jsx(EmptyState, {
    "data-test-id": "articles-table-empty-state",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.manage.zeroArticlesState.title"
    }),
    primaryContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Media, {
        align: "center",
        marginBlockEnd: "400",
        children: [/*#__PURE__*/_jsx(MediaLeft, {
          children: /*#__PURE__*/_jsx(IconCircle, {
            icon: NextIcon,
            size: "100",
            legacy: true,
            backgroundColor: "fill-accent-purple-default",
            color: "icon-primary-default"
          })
        }), /*#__PURE__*/_jsx(MediaBody, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.manage.zeroArticlesState.save_on_support"
          })
        })]
      }), /*#__PURE__*/_jsxs(Media, {
        align: "center",
        marginBlockEnd: "400",
        children: [/*#__PURE__*/_jsx(MediaLeft, {
          children: /*#__PURE__*/_jsx(IconCircle, {
            icon: NextIcon,
            size: "100",
            legacy: true,
            backgroundColor: "fill-accent-purple-default",
            color: "icon-primary-default"
          })
        }), /*#__PURE__*/_jsx(MediaBody, {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "knowledgeContentUI.manage.zeroArticlesState.description_jsx",
            elements: {
              UILink: Link
            },
            options: {
              href: getImportWizardUrl()
            }
          })
        })]
      }), /*#__PURE__*/_jsx(CreateArticleButton, {
        marginBlockStart: "400"
      })]
    }),
    secondaryContent: /*#__PURE__*/_jsx(Illustration, {
      name: "knowledge-base",
      width: "100%"
    }),
    secondaryContentWidth: 200
  });
};
export default ArticleZeroState;